import { ConfigFullForm } from 'components/forms/config-full-form/config-full-form';
import { useCallback } from 'react';
import { closeModal } from 'store/modals/modals.slice';

import { MODAL_CONFIG_FULL } from '../../../shared/constants/modals';
import { useAppDispatch, useAppSelector } from '../../../store';
import { Modal } from '../../template/modals/modal';

export const ConfigReportModal = () => {
  const dispatch = useAppDispatch();

  const modal = useAppSelector((state) =>
    state.modals.find((modal) => modal.name === MODAL_CONFIG_FULL),
  );
  const isDirty = useAppSelector((state) => state.formIsDirty.isDirty);

  const handleClose = useCallback(() => {
    dispatch(closeModal({ name: MODAL_CONFIG_FULL }));
  }, [dispatch]);

  if (!modal || !modal.isOpen) {
    return null;
  }

  return (
    <Modal formIsDirty={isDirty} close={handleClose}>
      <ConfigFullForm />
    </Modal>
  );
};
